module.exports = __webpack_public_path__ + "media/vhome.81557811.webm";